// @vendors
import { useTranslation } from 'react-i18next';

// @store
import { useLogoutStore } from '../../../store/useLogoutStore'
import { useSpinnerStore } from '../../../store/useSpinnerStore';

const LogoutModal = () => {
    const { open, handleLogout } = useLogoutStore();
    const { t } = useTranslation();
    const { openSpinner } = useSpinnerStore();

    const closeModal = () => handleLogout(false);

    const handleSignOut = () => {
        openSpinner(true);
        handleLogout(false)
        localStorage.clear();
        window.location.href = "/";
        setTimeout(() => {
            openSpinner(false);
        }, 1000);
    };

    return (
        <div className={!open ? "hidden" : "fixed w-full h-screen bg-transparent z-[100]"}>
            <div className="flex items-center justify-center h-screen w-full bg-black/50 pointer-events-none">
                <div className="p-[40px] rounded-lg max-w-[500px] bg-white">
                    <p className='text-[20px] text-center text-gray-500'>{t("professional.logout")}</p>

                    <div className="flex items-center justify-evenly w-full mt-[50px] pointer-events-auto">
                        <button
                            onClick={closeModal}
                            className="bg-[#525252] text-white px-4 py-2 rounded-lg"
                        >
                            {t("professional.cancelButton")}
                        </button>
                        <button
                            onClick={handleSignOut}
                            className="bg-[#F97068] text-white px-4 py-2 rounded-lg"
                        >
                            {t("professional.acceptButton")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogoutModal